"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PageSectionHeader } from '../../../structure/page-blocks';
import { usePageBuilder } from '../lib/usePageBuilder';
import { ComponentSelector } from '../components/ComponentSelector';
import { ComponentPropertiesForm } from '../components/ComponentPropertiesForm';
import { PageEngine } from '../components/PageEngine';
import { SaveLoadSection } from '../components/SaveLoadSection';
import "../../../../css/pixelated.global.css";
import './pagebuilder.scss';
/**
 * PageBuilderUI - Main orchestrator component
 * Composes all sub-components and manages layout with inline editing
 */
/**
 * PageBuilderUI — Main page builder orchestration UI. Composes selection, properties editing, preview, and save/load.
 *
 * @param {string} [props.apiEndpoint] - API endpoint base used for saving and loading page JSON.
 */
PageBuilderUI.propTypes = {
    /** API endpoint base for save/load operations (e.g., '/api/pagebuilder') */
    apiEndpoint: PropTypes.string,
};
export function PageBuilderUI({ apiEndpoint = '/api/pagebuilder' }) {
    const { pageJSON, setPageJSON, editableComponent, selectedPath, editMode, setEditableComponent, setSelectedPath, setEditMode, handleAddNewComponent, handleSelectComponent, handleEditComponent, cancelEdit, handleDeleteComponent, handleMoveUp, handleMoveDown, } = usePageBuilder();
    const [selectorKey, setSelectorKey] = React.useState(0);
    // Handle loading a saved page
    function handleLoadPage(data) {
        setPageJSON(data);
        setEditableComponent({});
        setSelectedPath('');
        setEditMode(null);
        setSelectorKey(prev => prev + 1);
    }
    // Wrap handleAddNewComponent to reset selector after adding
    function handleAddWithReset(component) {
        handleAddNewComponent(component);
        setSelectorKey(prev => prev + 1);
        setEditableComponent({});
    }
    return (_jsxs("div", { className: "row-2col", style: { gridTemplateColumns: "1fr 3fr", alignItems: "start" }, children: [_jsxs("div", { className: "grid-item", children: [_jsx(PageSectionHeader, { title: "Component Editor" }), _jsx(SaveLoadSection, { pageData: pageJSON, onLoad: handleLoadPage, apiEndpoint: apiEndpoint }), _jsx(ComponentSelector, { setEditableComponent: setEditableComponent, parentPath: selectedPath || undefined, editMode: editMode ? {
                            component: editMode.component.component,
                            props: editMode.component.props
                        } : undefined }, selectorKey), _jsx("br", {}), _jsx(ComponentPropertiesForm, { editableComponent: editableComponent, onSubmit: handleAddWithReset }), editMode && (_jsx("div", { children: _jsx("button", { onClick: cancelEdit, type: "button", className: "button", style: {
                                background: '#FFA726',
                                color: 'white',
                                transition: 'all 0.2s ease',
                            }, onMouseEnter: (e) => e.currentTarget.style.background = '#FB8C00', onMouseLeave: (e) => e.currentTarget.style.background = '#FFA726', children: "Cancel Edit" }) }))] }), _jsxs("div", { className: "grid-item", children: [_jsx(PageSectionHeader, { title: "Page Preview" }), _jsx("section", { id: "preview-section", children: _jsxs("div", { className: "section-container", children: [pageJSON.components.length > 0 ? (_jsx(PageEngine, { pageData: pageJSON, editMode: true, selectedPath: selectedPath, onEditComponent: handleEditComponent, onSelectComponent: handleSelectComponent, onDeleteComponent: handleDeleteComponent, onMoveUp: handleMoveUp, onMoveDown: handleMoveDown })) : (_jsx("p", { style: { color: '#666', fontStyle: 'italic', padding: '2rem', textAlign: 'center' }, children: "No components yet. Start by selecting a component above and adding it to your page." })), _jsxs("details", { style: { marginTop: '1rem' }, children: [_jsx("summary", { style: { cursor: 'pointer', userSelect: 'none' }, children: _jsx("strong", { children: "Page JSON" }) }), _jsx("pre", { style: {
                                                maxHeight: '400px',
                                                overflow: 'auto',
                                                fontSize: '0.875rem',
                                                background: '#f5f5f5',
                                                padding: '1rem',
                                                borderRadius: '4px',
                                            }, children: JSON.stringify(pageJSON, null, 2) })] })] }) })] })] }));
}
